<script lang="ts">
  import Checkmark from "../icons/Checkmark.svelte";

  export let active: boolean = false;
  export let onToggle: () => void;
  export let size: number = 32;
</script>

<button
  class="container"
  class:active
  on:click={onToggle}
  style="width: {size}px; height: {size}px; border-radius: {size / 2}px;"
>
  {#if active}
    <Checkmark size={size - 18} />
  {/if}
</button>

<style>
  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2px;
    background-color: var(--rekki-neutral-01);
  }

  .active {
    background-color: var(--rekki-neutral-04);
  }
</style>
